import { cn } from '@/lib/utils'

/** Max width for editor-tab / wide chat column (Cursor-like focus, not full-bleed). */
export const CHAT_EDITOR_FOCUS_MAX_CLASS = 'max-w-2xl'

/** Message column when chat is the agent rail (still capped on wide expanded panels). */
export const CHAT_COMPACT_FOCUS_MAX_CLASS = 'max-w-3xl'

export type ChatSurfaceVariant = 'compact' | 'comfortable' | 'editor' | undefined

/** Named container on ChatPane root - gutters query panel width, not the viewport. */
export const CHAT_PANE_CONTAINER_CLASS = '@container/chat-pane'

/** Editor tab and wide surfaces use a centered focus column; agent panel stays full rail width. */
export function isWideChatSurface(variant: ChatSurfaceVariant): boolean {
  return variant === 'editor' || variant === 'comfortable'
}

export function chatEditorFocusColumnClassName(className?: string): string {
  return cn('mx-auto w-full', CHAT_EDITOR_FOCUS_MAX_CLASS, className)
}

/**
 * Horizontal inset for the message stream (and sticky prompt chrome).
 * Wide surfaces: viewport breakpoints.
 * Compact agent rail: panel-width container queries - modest breathing room (not flush to the rail edge).
 */
export function chatMessageGutterClassName(
  className?: string,
  variant?: ChatSurfaceVariant,
): string {
  if (isWideChatSurface(variant)) {
    return cn('px-4 sm:px-6 lg:px-8 xl:px-10', className)
  }
  return cn(
    'px-3.5 @[420px]/chat-pane:px-4 @[560px]/chat-pane:px-5 @[720px]/chat-pane:px-6',
    className,
  )
}

/**
 * Horizontal inset for the composer footer.
 * Slightly tighter than the message stream so the prompt area stays compact.
 */
export function chatComposerGutterClassName(
  className?: string,
  variant?: ChatSurfaceVariant,
): string {
  if (isWideChatSurface(variant)) {
    return cn('px-4 sm:px-6 lg:px-8 xl:px-10', className)
  }
  return cn(
    'px-2.5 @[420px]/chat-pane:px-3 @[560px]/chat-pane:px-4 @[720px]/chat-pane:px-5',
    className,
  )
}

/** Composer footer vertical pad - tighter on the agent rail. */
export function chatComposerFooterPadClassName(variant?: ChatSurfaceVariant): string {
  return isWideChatSurface(variant) ? 'py-4' : 'py-3'
}
